import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    caution: {
        marginTop: '1rem',
        padding: '.5rem',
        marginBottom: '1rem',
    },
    image: {
        width: '50px',
        height: '50px'
    },
    item: {
        color: '#88ba60',
        fontSize: '1rem'
    }
}));

// フロー注意
function FlowCaution(){
    const classes = useStyles();

    return(
        <Paper className={classes.caution}>
            <Grid container>
                <Grid item xs={2}>
                    <img src="img/caution.png" className={classes.image}/>
                </Grid>
                <Grid item xs={10}>
                    <Typography className={classes.item}>
                        自筆証書遺言の作成の際に、財産目録の添付が必要になります。また、財産目録は、現在の時点において保有する資産状況を明らかにしたものです。
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default FlowCaution
